import http from '../plugins/axios'

export const getGlobalSettings = async (params) => {
  try {
    const response = await http.get(`/api/v2/global-settings`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateGlobalSetting = async (payload) => {
  try {
    const response = await http.post(`/api/v2/global-settings/bulk-create`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateGlobalSettingBulkUpdate = async (payload) => {
  try {
    const response = await http.put(`/api/v2/global-settings/bulk-update`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getLogisticRates = async (params) => {
  try {
    const response = await http.get(`/api/v2/logistic-rates`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getCouriers = async (params) => {
  try {
    const response = await http.get(`/api/v2/couriers`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const createLogisticRate = async (payload) => {
  try {
    const response = await http.post(`/api/v2/logistic-rates`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateWholesalePrice = async (id, payload) => {
  try {
    const response = await http.post(`/api/v2/wholesalable/${id}/wholesale-price`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteWholesalePrice = async (id) => {
  try {
    const response = await http.delete(`/api/v2/wholesalable/${id}/wholesale-price`, { data: { type: "GlobalSetting" } })
    return response.data
  } catch (error) {
    throw error
  }
}
export const deleteLogisticRates = async (payload) => {
  try {
    const response = await http.delete(`/api/v2/logistic-rates/multiple-delete`, { data: payload })
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteGlobalSettingBulkDelete = async (payload) => {
  try {
    const response = await http.delete(`/api/v2/global-settings/bulk-delete`, { data: payload })
    return response.data
  } catch (error) {
    throw error
  }
}

export const importLogisticRates = async (payload) => {
  try {
    const response = await http.post(`/api/v2/logistic-rates/import`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}
